import styled, { css } from 'styled-components';
import { FieldHelper as BaseHelper, primary, secondary, surfaceLiquid01, surfaceLiquid02 } from '@salutejs/plasma-core';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Field/Field');
export var FieldHelper = /*#__PURE__*/styled(BaseHelper).withConfig({
  componentId: "plasma-ui__sc-1nck119-0"
})(["padding-left:1rem;padding-right:1rem;"]); // TODO: https://github.com/salute-developers/plasma/issues/232

export var applyInputStyles = function applyInputStyles(_ref) {
  var $isFocused = _ref.$isFocused;
  return css(["background-color:", ";color:", ";transition:", ";&::placeholder{color:", ";}&:focus:not(:read-only){background-color:", ";}", ""], surfaceLiquid01, primary, function (_ref2) {
    var theme = _ref2.theme;
    return theme.lowPerformance ? 'unset' : 'background-color 0.1s ease-in-out';
  }, secondary, surfaceLiquid02, $isFocused && css(["background-color:", ";"], surfaceLiquid02));
};